import { Component, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/seguranca/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { CarteirinhaService } from '../carteirinha.service';
import { SecretariaService } from 'src/app/secretaria/secretaria.service';
import { Socio } from 'src/app/model/Socio';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-form-carteirinha',
  templateUrl: './form-carteirinha.component.html',
  styleUrls: ['./form-carteirinha.component.css']
})
export class FormCarteirinhaComponent implements OnInit {

  socio = new Socio;
  idSocio: any;
  idEmpresa: any;
  tipoSocio: any;
  payLoad: any;
  token: any;
  foto = '';
  qrCodeValue = '000000000';

  constructor(
    private carteirinhaService: CarteirinhaService,
    private rota: ActivatedRoute,
    private erro: ErrorHandler,
    private auth: AuthService,
    private rotaNavegar: Router,
    private jwtDecoder: JwtHelperService,    
    private secretariaService: SecretariaService,
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('access_token_xmanager');
    this.payLoad = this.jwtDecoder.decodeToken(this.token);
    window.scrollTo(0, 0);
    this.idSocio = this.payLoad.id;
    this.idEmpresa = this.payLoad.empresa.id;
    this.tipoSocio = this.payLoad.tipoSocio;
    this.buscarDadosCarteirinha();
    this.buscarFotoSocio();
  }

  buscarDadosCarteirinha() {

    this.carteirinhaService.buscarDadosCarteirinha(this.idSocio, this.idEmpresa, this.tipoSocio, this.token).subscribe(
      (dados: any) => {
        this.socio = dados;
        this.qrCodeValue = this.socio.cpf;
      }, erro => {
        this.erro.handleError(erro)
      }
    )
  }

  buscarFotoSocio() {
    this.secretariaService.buscarFotoSocio(this.payLoad.id, this.token).subscribe(
      (dados: any) => {
        if (dados) {
          this.foto = `data:image/png;base64,${dados.avatar[0].foto}`;
        }
        else {
          this.foto = 'assets/img/semfoto.jpg'
        }
      }
    )
  }

  async gerarPdf(): Promise<void> {

    const element = document.getElementById('carteiraPdf');

    if (!element) {
      return;
    }

    const canvas = await html2canvas(element, {
      scale: 4,
      useCORS: true,
      backgroundColor: '#ffffff'
    });

    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [53.98, 85.60]
    });

    pdf.addImage(
      imgData,
      'PNG',
      0,
      0,
      85.60,
      53.98
    );

    pdf.save('carteira.pdf');
  }
}
